import { render, staticRenderFns } from "./Invites.vue?vue&type=template&id=232cc1b4&scoped=true"
import script from "./Invites.vue?vue&type=script&lang=js"
export * from "./Invites.vue?vue&type=script&lang=js"
import style0 from "./Invites.vue?vue&type=style&index=0&id=232cc1b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232cc1b4",
  null
  
)

export default component.exports